import { Button, Card, Spinner, Row, Form, FormGroup, Col, Image} from 'react-bootstrap';
import formatCurrency from '../utils/currencyFormmter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { removeFromCart, updateQuantity } from '../redux/slices/cartSlice.slice';
import "../pages/inventory/scss/Storefront.scss"
import paymentLogo from "../assets/images/paystack-logo.webp"
import { PaystackButton } from 'react-paystack';


const Cart = ({cartItems, handleSubmit, requestStatus, printReceipt, clearCart, handleInput, orderNumber, payWithPaycode, handlePaymentOption, paymentConfig }) => {

    const totalPrice = cartItems.reduce((sum, item) => sum + (item.sales_price * item.quantity), 0)
    const { business = {} } = useSelector((state) => state.user)

    const dispatch = useDispatch()

    const vatAmount = totalPrice * (paymentConfig?.tax?.vat/100);
    const consumptionTaxAmount = totalPrice * (paymentConfig?.tax?.consumption_tax/100);
    const grandTotal = totalPrice + vatAmount + consumptionTaxAmount + (paymentConfig?.fee || 0) + parseFloat(paymentConfig?.tax?.delivery_fee);   

    // const componentProps = {
    //     email: paymentConfig?.payload?.email,
    //     amount: parseFloat(grandTotal),
    //     metadata: {
    //       customer_phone_number: paymentConfig?.payload?.phone_number, 
    //       customer_name: paymentConfig?.payload?.full_name,
    //       customer_email: paymentConfig?.payload?.email,
    //       merchant_id: paymentConfig?.merchantId,
    //       amount: grandTotal,
    //       currency: 'NGN',
    //     },
    //     publicKey: paymentConfig?.paystackKey,
    //     text: `Pay ${formatCurrency(grandTotal).with_currency}`,
    //     onSuccess: (data) => {
    //         // verifyPayment(data.trxref)
    //         // handleSubmit();
    //     },
    // }

    const handleRemoveFromCart = (id) => {
        dispatch(removeFromCart(id));
    };

    const handleQauntityUpdate = (id, quantity) => {
        if (quantity <= 0) {
            handleRemoveFromCart(id);
        } else {
        dispatch(updateQuantity({ id, quantity }));
        }
    };

    const handlePrint = () => {
        const currentDate = new Date().toLocaleString();
    
        const receiptContent = `
            <div class="header">
                <img src="${business.profile_image ?? ''}" alt="Company Logo" class="logo" width="70">
                <h1>${business.store_name ?? ''}</h1>
                <p>${business.store_address ?? ''}</p>
                <p>Phone: ${business.phone_number ?? ''}</p>
            </div>
            
            <div class="receipt-info">
                <p><strong>Order #: ${orderNumber}</strong></p>
                <p>Date: ${currentDate}</p>
            </div>
            
            <table>
                <thead>
                    <tr>
                        <th>Item</th>
                        <th>Qty</th>
                        <th>Price</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    ${cartItems.map(
                        (item) => `
                        <tr>
                            <td>${item.name}</td>
                            <td>${formatCurrency(item.quantity).formatted}</td>
                            <td>${formatCurrency(item.sales_price).with_currency}</td>
                            <td>${formatCurrency(item.sales_price * item.quantity).with_currency}</td>
                        </tr>
                        `
                    ).join("")}
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="3">Subtotal</td>
                        <td>${formatCurrency(totalPrice).with_currency}</td>
                    </tr>
                    <tr>
                        <td colspan="3">VAT (${paymentConfig?.tax?.vat}%)</td>
                        <td>${formatCurrency(vatAmount).with_currency}</td>
                    </tr>
                    <tr>
                        <td colspan="3">Consumption Tax (${paymentConfig?.tax.consumption_tax}%)</td>
                        <td>${formatCurrency(consumptionTaxAmount).with_currency}</td>
                    </tr>
                    <tr>
                        <td colspan="3">Delivery Fee</td>
                        <td>${formatCurrency(paymentConfig?.tax?.delivery_fee).with_currency}</td>
                    </tr>
                    <tr class="total">
                        <td colspan="3"><strong>Total</strong></td>
                        <td><strong>${formatCurrency(grandTotal).with_currency}</strong></td>
                    </tr>
                </tfoot>
            </table>
            
            <div class="footer">
                <p>Thank you for your purchase!</p>
            </div>
        `;
    
        const printWindow = window.open("", "", "width=450,height=600");
        printWindow.document.write(`
            <html>
                <head>
                    <title>Receipt - ${orderNumber}</title>
                    <style>
                        body {
                            font-family: 'Courier New', monospace;
                            margin: 20px;
                            max-width: 300px;
                            font-size: 14px;
                            line-height: 1.4;
                        }
                        .header {
                            text-align: center;
                            border-bottom: 2px dashed #000;
                            padding-bottom: 10px;
                            margin-bottom: 10px;
                        }
                        .logo {
                            max-width: 100px;
                            margin: 0 auto;
                            display: block;
                        }
                        h1 {
                            font-size: 20px;
                            margin: 10px 0;
                        }
                        .receipt-info {
                            margin: 10px 0;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 15px 0;
                        }
                        th, td {
                            padding: 5px;
                            text-align: left;
                        }
                        th {
                            background-color: #f0f0f0;
                            border-bottom: 2px solid #000;
                        }
                        td {
                            border-bottom: 1px dotted #666;
                        }
                        tfoot td {
                            padding-top: 10px;
                        }
                        .total {
                            font-weight: bold;
                            border-top: 2px solid #000;
                        }
                        .footer {
                            text-align: center;
                            border-top: 2px dashed #000;
                            padding-top: 10px;
                            margin-top: 10px;
                        }
                    </style>
                </head>
                <body>
                    ${receiptContent}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.print();
    };

    const handleEntry = (e) => {
        handleInput(e)
        if(paymentConfig?.isMarketPlace) {
            // setVatRate({vat: vatAmount, consumption_tax: consumptionTaxAmount})
        }
    }

  return (
    <>
        <Card className='border-0 shadow-none'>
            <Card.Header as="h5" className='bg-white text-center no-print'>
                {/* {paymentConfig.paystackKey} */}
                {paymentConfig?.showPaymentOptions ? "Order Payment" : "Your Cart"}
            </Card.Header>
            <Card.Body>
                {!printReceipt && !paymentConfig?.showPaymentOptions && cartItems.length > 0 ? (
                    <div className="cart-items cart no-print">
                        <table>
                            <thead>
                            <tr>
                                <th>Product</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {cartItems.map((item,index) => (
                                <tr key={item.id}>
                                <td>{index+1}. {item.name}</td>
                                <td>
                                    <input
                                    type="number"
                                    name="quantity"
                                    value={item.quantity}
                                    onChange={(e) =>
                                        handleQauntityUpdate(item.id, parseInt(e.target.value))
                                    }
                                    min="1"
                                    />
                                </td>
                                <td>{formatCurrency(item.sales_price).with_currency}</td>
                                <td>
                                    <button
                                    className="btn-plain btn-sm text-danger"
                                    onClick={() => handleRemoveFromCart(item.id)}
                                    >
                                    <FontAwesomeIcon icon={"times-circle"} />
                                    </button>
                                </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        <div className="total-area mt-2">
                            <p className="text-end">
                            <strong>SubTotal: {formatCurrency(totalPrice).with_currency}</strong>
                            </p>
                            <p className="text-end">
                                <strong>VAT {paymentConfig?.tax?.vat}%: {formatCurrency(vatAmount).with_currency}</strong>
                            </p>
                            <p className="text-end">
                                <strong>Consumption Tax {paymentConfig?.tax?.consumption_tax}%: {formatCurrency(consumptionTaxAmount).with_currency}</strong>
                            </p>
                            <p className="text-end">
                                <strong>Delivery Fee <FontAwesomeIcon icon={'info-circle'} title={paymentConfig?.tax?.delivery_note || ''} />: {formatCurrency(paymentConfig?.tax?.delivery_fee).with_currency}</strong>
                            </p>
                            <p className="text-end">
                            <strong>Total: {formatCurrency(grandTotal).with_currency}</strong>
                            </p>
                        </div>
                        {
                            paymentConfig?.tax?.delivery_note ? (
                                <>
                                    <div className='mt-2 mb-2 bg-light p-2 rounded'>
                                        <h6 className='mb-2'>Please Note: <FontAwesomeIcon icon={'info-circle'} /> </h6>
                                        <p>{paymentConfig?.tax?.delivery_note}</p>
                                    </div>
                                </>
                            ) : null
                        }
                        <div className="mt-6 d-flexb gap-4">
                            <div className="p-0 mb-2">
                                <label> Payment Method</label> 
                                <select
                                    name="payment_method"
                                    required
                                    className='ms-2c form-control form-control-sm'
                                    onChange={handleEntry}
                                >
                                    <option value="">--Select--</option>
                                    {
                                        paymentConfig?.isMarketPlace ? (
                                            <>
                                                <option value="card" selected={paymentConfig?.payload?.payment_method === 'card'}>Debit Card</option>
                                                <option value="paycode" selected={paymentConfig?.payload?.payment_method === 'paycode'}>Paycode Voucher</option>
                                                <option value="bank" selected={paymentConfig?.payload?.payment_method === 'bank'}>Bank Transfer</option>
                                            </>
                                        ) : 
                                        <>
                                            <option value="CASH">Cash</option>
                                            <option value="DEBIT CARD">Card</option>
                                            <option value="BANK TRANSFER">Bank Transfer</option>
                                            <option value="PAYCODE VOUCHER">Paycode Voucher</option>
                                            <option value="Others">Others</option>
                                        </>
                                    }
                                </select>
                                <p className="m-0 text-danger">
                                    <small>
                                        {paymentConfig?.payload?.payment_method === 'card' ? `You will be charged ${formatCurrency(paymentConfig?.fee).with_currency} as service fee.` : ''}
                                    </small>
                                </p>
                            </div>
                        </div>
                        {
                            !paymentConfig?.isMarketPlace && 
                            <>
                                {/* <div className="mt-6 d-flexb gap-4">
                                    <div className="p-0 mb-2">
                                        <label> Payment Method</label> 
                                        <select
                                            name="payment_method"
                                            required
                                            className='ms-2c form-control form-control-sm'
                                            onChange={handleEntry}
                                        >
                                            <option value="">--Select--</option>
                                            {
                                                paymentConfig?.isMarketPlace ? (
                                                    <>
                                                        <option value="card">Debit Card</option>
                                                        <option value="paycode">Paycode Voucher</option>
                                                    </>
                                                ) : 
                                                <>
                                                    <option value="CASH">Cash</option>
                                                    <option value="DEBIT CARD">Card</option>
                                                    <option value="BANK TRANSFER">Bank Transfer</option>
                                                    <option value="PAYCODE VOUCHER">Paycode Voucher</option>
                                                    <option value="Others">Others</option>
                                                </>
                                            }
                                        </select>
                                    </div>
                                </div> */}
                                <div className="p-0 mb-2 col-12">
                                    <label>Note</label> 
                                    <textarea name='notes' onChange={handleEntry} className='form-control form-control-sm'></textarea>
                                </div>
                            </>
                        }
                            {
                                paymentConfig?.isMarketPlace && (
                                    <Col md={12} xs={12} sm={12} className="mt-3 p-0">
                                        <Row>
                                            <FormGroup as={Col} md={6} xs={12} sm={12} className="mb-2">
                                            <Form.Label className="mb-0">Customer Name</Form.Label>
                                            <Form.Control
                                                required
                                                placeholder="Itodo Onuh"
                                                name="full_name"
                                                onChange={handleEntry}
                                                className="form-control-sm"
                                                value={paymentConfig?.payload?.full_name || ""}
                                            />
                                            </FormGroup>

                                            <FormGroup as={Col} md={6} xs={12} sm={12} className="mb-2">
                                                <Form.Label className="mb-0">Phone Number</Form.Label>
                                                <Form.Control
                                                    type="tel"
                                                    required
                                                    placeholder="081234567890"
                                                    name="phone_number"
                                                    onChange={handleEntry}
                                                    className="form-control-sm"
                                                    maxLength={11}
                                                    minLength={11}
                                                    value={paymentConfig?.payload?.phone_number || ""}
                                                />
                                            </FormGroup>

                                            <FormGroup as={Col} md={12} xs={12} sm={12} className="mb-2">
                                                <Form.Label className="mb-0">Customer Email</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    required
                                                    placeholder="itodo@xyz.com"
                                                    name="email"
                                                    onChange={handleEntry}
                                                    className="form-control-sm"
                                                    value={paymentConfig?.payload?.email || ""}
                                                />
                                            </FormGroup>

                                            <FormGroup as={Col} md={12} xs={12} sm={12} className="mb-2">
                                                <Form.Label className="mb-0">Note</Form.Label>
                                                <textarea
                                                    name="notes"
                                                    onChange={handleEntry}
                                                    className="form-control form-control-sm"
                                                    defaultValue={paymentConfig?.payload?.notes}
                                                ></textarea>
                                            </FormGroup>
                                        </Row>
                                    </Col>
                                )
                            }
                        <Button 
                            variant="primary" 
                            type='button' 
                            className="w-100 mt-3"
                            onClick={!paymentConfig?.isMarketPlace ? handleSubmit : handlePaymentOption}
                        >
                           {!paymentConfig?.isMarketPlace ? 'Checkout' : 'Proceed'} {requestStatus && <Spinner size='sm' /> }
                        </Button>
                        {
                            paymentConfig?.isMarketPlace && 
                            <div className='mt-4'>
                                <Image src={paymentLogo} alt="payment" className='img-fluid' />
                            </div>
                        }
                    </div>
                ) : !printReceipt && !paymentConfig?.showPaymentOptions && (
                    <p className='text-center'>Your cart is empty</p>
                )}

                {paymentConfig?.showPaymentOptions && paymentConfig?.payload?.payment_method === "paycode" && (
                    <>
                        <h6 className='mb-3'>PayCode Payment</h6>
                        <hr />
                        <Row>
                            <FormGroup as={Col} md={12} className="mb-2">
                                <Form.Label>Amount</Form.Label>
                                <Form.Control
                                    required
                                    placeholder="N0.00"
                                    name="amount"
                                    disabled
                                    value={ formatCurrency(grandTotal).with_currency}
                                />
                            </FormGroup>
                            <FormGroup as={Col} md={12} className="mb-2">
                                <Form.Label className='mb-0'>PayCode</Form.Label>
                                <Form.Control
                                    required
                                    placeholder="paycode token"
                                    name="token"
                                    onChange={handleEntry}
                                    value={paymentConfig?.payload?.token || ""}
                                    maxLength={6}
                                    minLength={6}
                                />
                            </FormGroup>

                            <FormGroup as={Col} md={12} className="mb-2">
                                <Form.Label className='mb-0'>Secret</Form.Label>
                                <Form.Control
                                    type="password"
                                    required
                                    placeholder="Secret"
                                    name="secret"
                                    onChange={handleEntry}
                                />
                            </FormGroup>

                            <FormGroup as={Col} md={12} className="mb-2 d-flex justify-content-between gap-2">
                                <Button
                                    type="button"
                                    variant="outline-primary"
                                    size='sm'
                                    onClick={ handlePaymentOption}
                                >
                                    Go Back
                                </Button>
                                <Button
                                    type="button"
                                    variant="primary"
                                    size='sm'
                                    onClick={payWithPaycode}
                                >
                                    Pay now{" "}
                                    <Spinner
                                        animation={paymentConfig?.loading ? "border" : null}
                                        role="status"
                                        size="sm"
                                    ></Spinner>
                                </Button>
                            </FormGroup>
                        </Row>
                    </>
                )}

                {
                    paymentConfig?.showPaymentOptions && paymentConfig?.payload?.payment_method === "card" ? (
                        <>
                            <div className="d-flex justify-content-between">
                                <h5>Credit/Debit Card</h5>
                                <h5>{formatCurrency(grandTotal).with_currency}</h5>
                            </div>
                            <hr/>
                            <Form>
                                <Row>
                                    <Form.Group as={Col} md={12} className="mb-2">
                                        <Form.Text>Email</Form.Text>
                                        <Form.Control
                                            type="email"
                                            placeholder="Email"
                                            name="email"
                                            value={paymentConfig?.payload?.email}
                                            readOnly
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md={12} className="mb-2">
                                        <Form.Text>Phone Number</Form.Text>
                                        <Form.Control
                                            type="tel"
                                            placeholder="Phone Number"
                                            readOnly
                                            name="phone_number"
                                            maxLength={11}
                                            minLength={11}
                                            value={paymentConfig?.payload?.phone_number}
                                        />
                                    </Form.Group>
                                </Row>
                                <p className="text-primary font-bold">You will be charged {formatCurrency(paymentConfig?.fee).with_currency} as service fee. </p>
                            </Form>
                            <div className="d-flex justify-content-between">
                                <Button
                                    type="button"
                                    variant="outline-primary"
                                    size='sm'
                                    onClick={ handlePaymentOption }
                                >
                                    Go Back
                                </Button>
                                <Button
                                    type="button"
                                    variant="primary"
                                    size='sm'
                                    onClick={ handleSubmit }
                                >
                                    Pay Now                                   
                                    <Spinner
                                        animation={paymentConfig?.loading ? "border" : null}
                                        role="status"
                                        size="sm"
                                    />
                                </Button>
                                {/* <PaystackButton className="btn btn-primary" {...componentProps} /> */}
                            </div>
                            {/* <Button type="button" onClick={() => setState((prevState)=> ({...prevState, 'show_rating_form': true}))}>Rating</Button> */}
                        </>
                    ) : null
                }

                {
                    printReceipt && (
                        <div className="cart-items cart printarea">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Quantity</th>
                                        <th>Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cartItems.map((item,index) => (
                                        <tr key={item.id}>
                                            <td>{index+1}. {item.name}</td>
                                            <td>
                                                x{formatCurrency(item.quantity).formatted}
                                            </td>
                                            <td>{formatCurrency(item.sales_price).with_currency}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="total-area mt-2">
                                <p className="text-end">
                                    <strong>SubTotal: {formatCurrency(totalPrice).with_currency}</strong>
                                </p>
                                <p className="text-end">
                                    <strong>VAT {paymentConfig?.tax?.vat}%: {formatCurrency(vatAmount).with_currency}</strong>
                                </p>
                                <p className="text-end">
                                    <strong>VAT {paymentConfig?.tax.consumption_tax}%: {formatCurrency(consumptionTaxAmount).with_currency}</strong>
                                </p>
                                <p className="text-end">
                                    <strong>Delivery Fee: {formatCurrency(paymentConfig?.tax?.delivery_fee).with_currency}</strong>
                                </p>
                                <p className="text-end">
                                    <strong>Total: {formatCurrency(grandTotal).with_currency}</strong>
                                </p>
                            </div>
                        </div>
                    ) 
                }
            </Card.Body>
            {
                printReceipt && (
                    <Card.Footer className='bg-white border-0 d-flex justify-content-between'>
                        <Button type='button' variant='primary' className='no-print' onClick={clearCart}>
                            Back to store 
                        </Button>
                        {/* {
                            !paymentConfig?.isMarketPlace && ( */}
                                <Button variant='primary' type='button' className='no-print' onClick={handlePrint}>
                                    Print  <FontAwesomeIcon icon={'print'} style={{"fontSize": "20px"}} />
                                </Button>
                            {/* )
                        } */}
                    </Card.Footer>
                )
            }
        </Card>
    </>
  );
};

export default Cart